import emitter from "tiny-emitter/instance";

export const bus = {
  $emit: (...args) => emitter.emit(...args),
  $off: (...args) => emitter.off(...args),
  $on: (...args) => emitter.on(...args),
  $once: (...args) => emitter.once(...args),
};

export default ({ app }) => {
  // eslint-disable-next-line no-param-reassign
  app.config.globalProperties.$emitter = bus;
};
